import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';

import * as shapes from '../../shapes';
import FlatRateForm from '../FlatRateForm';
import PercentageForm from '../PercentageForm';
import Switch from '../../../../../common/checkboxSwitch';
import CancelButtonLink from '../../../../../common/buttons/cancelButtonLink';

const ParentForm = props => (
  <div className="c-wrapper s-v2">
    <div
      className={cx('u-margin-auto', {
        'u-max-width-530': props.commissionTiersType === 'flatAmount',
        'u-max-width-1200': props.commissionTiersType === 'percentage',
      })}
    >
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={props.handleSubmit}>
          <h2 className="c-heading c-heading--lightgrey u-mb">Commission Tiers</h2>
          <div className="u-mb">
            <Switch label="Cumulative Commission" name="cumulativeCommission" />
          </div>

          <ul className="layout layout--auto u-pb+ c-shop-commissions-tabs">
            <li className="layout__item">
              <Link
                onClick={() => props.setActiveTab('services')}
                className={cx('c-nav-tab u-type--capitalize u-cursor-pointer', {
                  'is-active': props.activeTab === 'services',
                })}
              >
                Services
              </Link>
            </li>
            <li className="layout__item">
              <Link
                onClick={() => props.setActiveTab('products')}
                className={cx('c-nav-tab u-type--capitalize u-cursor-pointer', {
                  'is-active': props.activeTab === 'products',
                })}
              >
                Products
              </Link>
            </li>
          </ul>
          <div className="u-mb+" display-if={props.canSetFlatRate}>
            <div className="label-primary u-mb--">Commission Type</div>
            <label className="c-radio u-mr++">
              <input
                type="radio"
                className="c-radio__input"
                checked={props.commissionTiersType === 'percentage'}
                onChange={() => props.changeCommissionType('percentage')}
              />
              <span className="c-radio__trigger" />
              <span className="c-radio__label">
                Percentage
              </span>
            </label>
            <label className="c-radio">
              <input
                type="radio"
                className="c-radio__input"
                checked={props.commissionTiersType === 'flatAmount'}
                onChange={() => props.changeCommissionType('flatAmount')}
              />
              <span className="c-radio__trigger" />
              <span className="c-radio__label">
                Flat Rate
              </span>
            </label>
          </div>

          <FlatRateForm
            tierKeyName="commissionTiers"
            disabled={props.submitting}
            display-if={props.activeTab === 'services' && props.commissionTiersType === 'flatAmount'}
          />
          <FlatRateForm
            tierKeyName="productCommissionTiers"
            disabled={props.submitting}
            display-if={props.activeTab === 'products' && props.commissionTiersType === 'flatAmount'}
          />

          <PercentageForm
            tierKeyName="commissionTiers"
            barbers={props.initialValues.barbers}
            disabled={props.submitting}
            display-if={props.activeTab === 'services' && props.commissionTiersType === 'percentage'}
          />
          <PercentageForm
            tierKeyName="productCommissionTiers"
            barbers={props.initialValues.barbers}
            disabled={props.submitting}
            display-if={props.activeTab === 'products' && props.commissionTiersType === 'percentage'}
          />
          <div className="c-separator u-mv" />
          <div className="u-text-right">
            <CancelButtonLink link={props.baseUrl} content="Cancel" />
            <button
              type="submit"
              className="c-btn u-width-120"
              disabled={props.submitting}
            >
              <span className="c-btn__text">Save</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
);

ParentForm.propTypes = {
  handleSubmit: shapes.handler.isRequired,
  submitting: shapes.flag.isRequired,
  baseUrl: shapes.url.isRequired,
  setActiveTab: shapes.handler.isRequired,
  commissionTiersType: shapes.commissionTierType.isRequired,
  activeTab: PropTypes.string.isRequired,
  changeCommissionType: shapes.handler.isRequired,
  initialValues: PropTypes.object.isRequired,
  canSetFlatRate: shapes.flag.isRequired,
};

export default ParentForm;
